import { Component, OnInit, Inject } from '@angular/core';
import { InputDataComponent } from '../input-data/input-data.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DBService } from '../../../services/db.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Activity, ActivityStatus } from '../../../model/activity';
import { Company } from '../../../model/company';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-new-activity',
  templateUrl: './new-activity.component.html',
  styleUrls: ['./new-activity.component.css'],
  providers: [DBService, AuthenticationService]
})
export class NewActivityComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  inputData: string;

  activity: Activity;

  companies: Company[];

  loading: boolean;

  uid: string;

  title: string;

  userCompanyUID: string;

  constructor(
    public dialogRef: MatDialogRef<InputDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dbService: DBService, private authService: AuthenticationService) {
      this.activity = new Activity();
      this.loading = true;

      $('#overlay').show();
      this.updateLabels();

      this.uid = data.uid;
      if (this.uid) {
        this.title = 'Editar Atividade';
      } else {
        this.title = 'Nova Atividade';
      }

      if (!this.authService.isAdmin()) {
        this.userCompanyUID = this.authService.getUserCompany();
      }

      this.initData();
  }

  private initData() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
          this.activity.companyUID = this.userCompanyUID;
        } else {
          this.companies = companies;
        }

        if (this.uid) {
          this.setupEdit();
        } else {
          this.setupNew();
        }
      });
  }

  private setupNew() {
    this.activity = new Activity();
    this.authService.getCurrentUser().subscribe(currentUser => this.activity.sentUserUID = currentUser.uid);

    this.loading = false;
  }

  private setupEdit() {
    this.dbService.getObject<Activity>(`activities/${this.uid}`)
      .then(activity => {
        this.activity = activity;
        this.loading = false;
      }).catch(error => console.log(error));
  }

  hideOverlay(): void {
    $('#overlay').hide();
  }

  ngOnInit() {
  }

  onChange(event) {
    const dateParts = this.activity.expirationDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.activity.expirationDate;
    } else {
      this.activity.expirationDate = date.getTime();
    }
  }

  save() {
    if (this.uid) {
      this.edit();
    } else {
      this.create();
    }
  }

  private edit() {
    const now = Date.now();
    if (this.activity.expirationDate <= now && this.activity.status != ActivityStatus.DONE) {
      this.activity.status = ActivityStatus.EXPIRED;
    } else if (this.activity.expirationDate > now && this.activity.status != ActivityStatus.DONE) {
      this.activity.status = ActivityStatus.TODO;
    }

    const updatingObj =  {
      category: this.activity.category,
      companyUID: this.activity.companyUID,
      description: this.activity.description,
      status: this.activity.status,
      expirationDate: this.activity.expirationDate,
      expirationDateString: this.activity.expirationDateString
    };

    this.dbService.update(`activities/${this.uid}`, updatingObj)
      .then(result => {
        Materialize.toast('Atividade atualizada com sucesso', 2000);
        this.hideOverlay();
      }).catch(error => console.log(error));
  }

  private create() {
    this.activity.creationDate = Date.now();
    if (this.activity.expirationDate <= this.activity.creationDate) {
      this.activity.status = ActivityStatus.EXPIRED;
    } else {
      this.activity.status = ActivityStatus.TODO;
    }

    this.dbService.insertInList<Activity>('/activities', this.activity)
      .then(result => {
        Materialize.toast('Atividade cadastrada com sucesso', 2000);
        this.hideOverlay();
      }).catch(error => console.log(error));
  }

  private updateLabels() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partials/new-activity/new-activity.component.ts